import { DiagnosisModel, IDiagnosisModel } from "./DiagnosisModel";
import { IModel, Model, ModelRecord } from "./Model";

export interface IVisitDiagnosisModel extends IModel {
    visitDiagnosisId: number;
    diagnosisId: number;
    visitId: number;
    diagnosis: IDiagnosisModel;
}

export class VisitDiagnosisModel extends Model implements ModelRecord<IVisitDiagnosisModel> {
    visitDiagnosisId: number;
    diagnosisId: number;
    visitId: number;
    diagnosis: DiagnosisModel;

    constructor(params: Partial<IVisitDiagnosisModel>) {
        super(params);
        this.visitDiagnosisId = params.visitDiagnosisId ?? 0;
        this.diagnosisId = params.diagnosisId ?? 0;
        this.visitId = params.visitId ?? 0;
        this.diagnosis = new DiagnosisModel(params.diagnosis);
    }
}
